import React from 'react';
import styles from './Quiz.module.css';
import { motion, AnimatePresence } from 'motion/react';
import Question from '../Question/Question';
import { ClassicQuiz, QuestionImgQuiz } from './DifferentQuizzes';

const Quiz = ({
  variants,
  title,
  questionImgUrl,
  currentState,
  marginTopQuiz,
  idVote,
}) => {
  const getCurrentTypeQuize = () => {
    if (questionImgUrl) {
      return 'questionImg';
    } else return 'classic';
  };

  const quizComponents = {
    classic: ClassicQuiz,
    questionImg: QuestionImgQuiz,
  };

  const isStateCorrectVar = ['S3'].includes(currentState);
  const CurrentQuiz = quizComponents[getCurrentTypeQuize()];

  const durationQuestion = 0.3 + (title?.length - 1) * 0.02 || 0.5;

  return (
    <div
      className={styles.container}
      style={{ marginTop: `${Number(marginTopQuiz)}rem` }}
    >
      <Question title={title} questionImgUrl={questionImgUrl} />

      <AnimatePresence mode="popLayout">
        <motion.div
          className={styles.containerQuiz}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.7 }}
          key={idVote}
        >
          {CurrentQuiz && (
            <CurrentQuiz
              initDelay={durationQuestion}
              variants={variants}
              isStateCorrectVar={isStateCorrectVar}
              questionImgUrl={questionImgUrl}
            />
          )}
        </motion.div>
      </AnimatePresence>
    </div>
  );
};

export default React.memo(Quiz);
